
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function VRFServicesPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const whatsappNumber = '+971506738495';
  const phoneNumbers = ['+971506738495', '+971585308822', '+971566610846'];

  const services = [
    {
      title: 'VRF System Installation',
      description: 'Professional installation of Variable Refrigerant Flow systems for optimal energy efficiency and climate control in commercial and residential buildings.',
      icon: 'ri-tools-line'
    },
    {
      title: 'Preventive Maintenance',
      description: 'Regular scheduled maintenance to ensure your VRF system operates at peak performance, preventing costly breakdowns and extending system lifespan.',
      icon: 'ri-settings-3-line'
    },
    {
      title: 'Emergency Repairs',
      description: '24/7 emergency repair services for VRF systems. Our expert technicians respond quickly to minimize downtime and restore comfort.',
      icon: 'ri-alarm-warning-line'
    },
    {
      title: 'System Diagnostics',
      description: 'Advanced diagnostic services using state-of-the-art equipment to identify and resolve VRF system issues efficiently.',
      icon: 'ri-search-line'
    },
    {
      title: 'Performance Optimization',
      description: 'System tuning and optimization services to improve energy efficiency, reduce operating costs, and enhance overall performance.',
      icon: 'ri-speed-up-line'
    },
    {
      title: 'Parts Replacement',
      description: 'Genuine VRF system parts replacement and supply. We stock quality components for all major VRF brands.',
      icon: 'ri-refresh-line'
    }
  ];

  const vrfImages = [
    'https://public.readdy.ai/ai/img_res/a50abd927de7d8b996f601d63c95726f.jpg',
    'https://readdy.ai/api/search-image?query=skilled%20engineer%20repairing%20vrf%20indoor%20cassette%20unit%20in%20commercial%20ceiling%20with%20clean%20white%20background%20showing%20professional%20maintenance%20work%20on%20climate%20control%20system%20with%20tools%20and%20equipment&width=1200&height=800&seq=vrf-service2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=technician%20installing%20multiple%20vrf%20indoor%20units%20on%20commercial%20building%20wall%20with%20clean%20white%20background%20showing%20professional%20air%20conditioning%20installation%20work%20and%20modern%20cooling%20equipment&width=1200&height=800&seq=vrf-service3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=close%20up%20of%20vrf%20system%20control%20panel%20and%20wiring%20with%20technician%20performing%20diagnostic%20testing%20on%20clean%20white%20background%20showing%20advanced%20climate%20control%20technology%20and%20professional%20maintenance&width=1200&height=800&seq=vrf-service4&orientation=landscape',
    'https://readdy.ai/api/search-image?query=large%20commercial%20vrf%20outdoor%20condensing%20units%20installation%20on%20building%20rooftop%20with%20clean%20white%20background%20showing%20professional%20hvac%20equipment%20setup%20and%20multiple%20cooling%20systems&width=1200&height=800&seq=vrf-service5&orientation=landscape',
    'https://readdy.ai/api/search-image?query=technician%20cleaning%20and%20servicing%20vrf%20indoor%20unit%20filters%20and%20components%20with%20clean%20white%20background%20showing%20preventive%20maintenance%20work%20on%20air%20conditioning%20system&width=1200&height=800&seq=vrf-service6&orientation=landscape',
    'https://readdy.ai/api/search-image?query=modern%20vrf%20system%20refrigerant%20piping%20installation%20with%20insulation%20in%20commercial%20building%20on%20clean%20white%20background%20showing%20professional%20copper%20pipe%20work%20and%20connections&width=1200&height=800&seq=vrf-service7&orientation=landscape',
    'https://readdy.ai/api/search-image?query=engineer%20using%20digital%20tools%20to%20diagnose%20vrf%20system%20performance%20with%20laptop%20and%20gauges%20on%20clean%20white%20background%20showing%20advanced%20hvac%20troubleshooting%20and%20technical%20analysis&width=1200&height=800&seq=vrf-service8&orientation=landscape'
  ];

  const benefits = [
    {
      title: 'Energy Efficiency',
      description: 'VRF systems can reduce energy consumption by up to 30% compared to traditional HVAC systems',
      icon: 'ri-leaf-line'
    },
    {
      title: 'Individual Control',
      description: 'Each zone can be controlled independently for personalized comfort and efficiency',
      icon: 'ri-remote-control-line'
    },
    {
      title: 'Quiet Operation',
      description: 'Advanced technology ensures minimal noise levels for comfortable indoor environments',
      icon: 'ri-volume-mute-line'
    },
    {
      title: 'Space Saving',
      description: 'Compact design requires less installation space compared to conventional systems',
      icon: 'ri-layout-grid-line'
    }
  ];

  const bgImage = 'https://static.readdy.ai/image/40f4082868c46b06892898a13f9794b5/815ee54ab89ffeb341f41028a81ab7f8.jpeg';

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
    console.log('Form submitted:', data);
    // Here you would typically send the data to your backend
    alert('Thank you for your request! We will contact you soon.');
    e.target.reset();
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-500 text-white py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-between items-center text-sm">
            <div className="flex items-center gap-6">
              <a href={`tel:${phoneNumbers[0]}`} className="hover:text-blue-100 transition-colors flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>{phoneNumbers[0]}</span>
              </a>
              <a href="mailto:Goldenrock_uae@yahoo.com" className="hover:text-blue-100 transition-colors flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>Goldenrock_uae@yahoo.com</span>
              </a>
            </div>
            <div className="flex items-center gap-4">
              <a href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="hover:text-blue-100 transition-colors">
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a href="#" className="hover:text-blue-100 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="hover:text-blue-100 transition-colors">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="hover:text-blue-100 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Header */}
      <header className="bg-white shadow-md sticky top-0 z-50 border-b border-blue-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center gap-3">
              <img src="https://static.readdy.ai/image/40f4082868c46b06892898a13f9794b5/f825deb031b992e693696193511051c7.jpeg" alt="Golden Rock Logo" className="h-16 w-auto" />
              <div>
                <h1 className="text-xl font-bold text-blue-600">GOLDEN ROCK ELECTRO MECHANICAL WORKS L.L.C</h1>
                <p className="text-xs text-gray-700 font-arabic">جولدن روك للأعمال الكهروميكانيكية ذ.م.م</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">Home</Link>
              <a href="/#services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">Services</a>
              <a href="/#portfolio" className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">Portfolio</a>
              <a href="/#contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">Contact</a>
              <a href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white px-6 py-2 rounded-full hover:bg-green-600 transition-colors flex items-center gap-2 whitespace-nowrap">
                <i className="ri-whatsapp-line text-lg"></i>
                <span>WhatsApp</span>
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-blue-600 hover:text-blue-700 w-10 h-10 flex items-center justify-center cursor-pointer"
              aria-label="Toggle mobile menu"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && (
            <nav className="lg:hidden py-4 border-t border-blue-200">
              <div className="flex flex-col gap-4">
                <Link to="/" className="text-gray-700 hover:text-blue-600 font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>Home</Link>
                <a href="/#services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>Services</a>
                <a href="/#portfolio" className="text-gray-700 hover:text-blue-600 font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>Portfolio</a>
                <a href="/#contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors" onClick={() => setMobileMenuOpen(false)}>Contact</a>
                <a href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white px-6 py-2 rounded-full hover:bg-green-600 transition-colors flex items-center justify-center gap-2 whitespace-nowrap">
                  <i className="ri-whatsapp-line text-lg"></i>
                  <span>WhatsApp</span>
                </a>
              </div>
            </nav>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative text-white py-32" style={{ backgroundImage: `url(${vrfImages[0]})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-blue-900/85"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <h2 className="text-5xl font-bold mb-6 leading-tight text-white">VRF System Repair & Maintenance</h2>
            <p className="text-xl mb-8 text-blue-50">Expert Variable Refrigerant Flow system installation, repair, and maintenance services across UAE. Ensuring optimal performance and energy efficiency for your climate control needs.</p>
            <div className="flex flex-wrap gap-4">
              <a href="#contact" className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap">Request Service</a>
              <a href="#services" className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap">Our Services</a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 relative" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-blue-600 mb-4">VRF SERVICES WE OFFER</h2>
            <p className="text-xl text-gray-700">Comprehensive VRF system solutions for residential and commercial properties</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white border border-blue-200 rounded-lg shadow-lg p-8 hover:shadow-2xl hover:border-blue-400 transition-all group cursor-pointer">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-blue-600 mb-3">{service.title}</h3>
                <p className="text-gray-700">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20 relative" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-blue-600 mb-4">OUR VRF PROJECTS</h2>
            <p className="text-xl text-gray-700">Professional VRF system installations and maintenance work</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {vrfImages.map((image, index) => (
              <div key={index} className="relative h-96 rounded-lg overflow-hidden shadow-lg border border-blue-200 group cursor-pointer">
                <img 
                  src={image} 
                  alt={`VRF Service ${index + 1}`}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-6">
                  <p className="text-white font-semibold text-lg">VRF Service Project {index + 1}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 relative" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-blue-600 mb-4">WHY CHOOSE VRF SYSTEMS?</h2>
            <p className="text-xl text-gray-700">Advanced technology for superior comfort and efficiency</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white border border-blue-200 rounded-lg shadow-lg p-8 text-center hover:shadow-2xl hover:border-blue-400 transition-all">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${benefit.icon} text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-blue-600 mb-3">{benefit.title}</h3>
                <p className="text-gray-700">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 relative" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-blue-600 mb-6">Why Choose Golden Rock for VRF Services?</h2>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-blue-600 mb-2">Certified Technicians</h3>
                    <p className="text-gray-700">Our team consists of highly trained and certified VRF system specialists with years of experience in installation, repair, and maintenance.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-blue-600 mb-2">24/7 Emergency Service</h3>
                    <p className="text-gray-700">We provide round-the-clock emergency repair services to ensure your VRF system is always operational when you need it most.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-price-tag-3-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-blue-600 mb-2">Competitive Pricing</h3>
                    <p className="text-gray-700">We offer transparent, competitive pricing with no hidden costs. Get quality VRF services that fit your budget.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-2-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-blue-600 mb-2">Excellent Customer Support</h3>
                    <p className="text-gray-700">Our dedicated customer support team is always ready to assist you with any questions or concerns about your VRF system.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src={vrfImages[4]} 
                alt="VRF Installation"
                className="w-full h-auto rounded-lg shadow-2xl border-2 border-blue-200 object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 relative" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-blue-600 mb-4">REQUEST VRF SERVICE</h2>
            <p className="text-xl text-gray-700">Contact us today for professional VRF system services</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-blue-600 mb-6">Get In Touch</h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-600 mb-2">Phone Numbers</h4>
                    {phoneNumbers.map((phone, index) => (
                      <a key={index} href={`tel:${phone}`} className="block text-gray-700 hover:text-blue-600 transition-colors mb-1">
                        {phone}
                      </a>
                    ))}
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-600 mb-2">Email</h4>
                    <a href="mailto:Goldenrock_uae@yahoo.com" className="text-gray-700 hover:text-blue-600 transition-colors">
                      Goldenrock_uae@yahoo.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-500 text-white rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-blue-600 mb-2">WhatsApp</h4>
                    <a href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-green-600 transition-colors">
                      {whatsappNumber}
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-8 p-6 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-lg">
                <h4 className="text-xl font-bold mb-4">Emergency Service Available</h4>
                <p className="mb-4">Need urgent VRF repair? We offer 24/7 emergency services to get your system running quickly.</p>
                <a href={`tel:${phoneNumbers[0]}`} className="inline-flex items-center gap-2 bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap">
                  <i className="ri-phone-line"></i>
                  Call Now
                </a>
              </div>
            </div>

            <div className="bg-white border border-blue-200 p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold text-blue-600 mb-6">Request a Quote</h3>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name"
                    className="w-full px-4 py-3 bg-white border border-blue-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email"
                    className="w-full px-4 py-3 bg-white border border-blue-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="your@email.com"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                  <input 
                    type="tel" 
                    id="phone" 
                    name="phone"
                    className="w-full px-4 py-3 bg-white border border-blue-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    placeholder="+971 XX XXX XXXX"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="service-type" className="block text-sm font-medium text-gray-700 mb-2">Service Type</label>
                  <select 
                    id="service-type" 
                    name="service-type"
                    className="w-full px-4 py-3 pr-8 bg-white border border-blue-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all appearance-none cursor-pointer"
                    required
                  >
                    <option value="">Select a service</option>
                    <option value="installation">VRF Installation</option>
                    <option value="maintenance">Preventive Maintenance</option>
                    <option value="repair">Emergency Repair</option>
                    <option value="diagnostics">System Diagnostics</option>
                    <option value="optimization">Performance Optimization</option>
                    <option value="parts">Parts Replacement</option>
                  </select>
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                  <textarea 
                    id="message" 
                    name="message"
                    rows={4}
                    className="w-full px-4 py-3 bg-white border border-blue-200 text-gray-900 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all resize-none"
                    placeholder="Tell us about your VRF system needs..."
                    required
                  ></textarea>
                </div>
                <button 
                  type="submit" 
                  className="w-full bg-gradient-to-r from-blue-600 to-blue-500 text-white px-8 py-4 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  Request Quote
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative text-gray-700 py-12" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute inset-0 bg-white/95"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img src="https://static.readdy.ai/image/40f4082868c46b06892898a13f9794b5/f825deb031b992e693696193511051c7.jpeg" alt="Golden Rock Logo" className="h-12 w-auto" />
                <div>
                  <h3 className="text-lg font-bold text-blue-600">GOLDEN ROCK</h3>
                  <p className="text-xs text-gray-600">Electro Mechanical Works</p>
                </div>
              </div>
              <p className="text-gray-600 text-sm">
                Your trusted partner for VRF system solutions in UAE.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-blue-600 mb-4">VRF Services</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Installation</a></li>
                <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Maintenance</a></li>
                <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Repair</a></li>
                <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Diagnostics</a></li>
                <li><a href="#" className="text-gray-600 hover:text-blue-600 transition-colors">Parts Supply</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-blue-600 mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="text-gray-600 hover:text-blue-600 transition-colors">Home</Link></li>
                <li><a href="/#services" className="text-gray-600 hover:text-blue-600 transition-colors">All Services</a></li>
                <li><a href="/#portfolio" className="text-gray-600 hover:text-blue-600 transition-colors">Portfolio</a></li>
                <li><a href="/#about" className="text-gray-600 hover:text-blue-600 transition-colors">About Us</a></li>
                <li><a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors">Contact</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold text-blue-600 mb-4">Contact Info</h4>
              <ul className="space-y-3 text-sm">
                {phoneNumbers.map((phone, index) => (
                  <li key={index}>
                    <a href={`tel:${phone}`} className="text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-2">
                      <i className="ri-phone-line"></i>
                      {phone}
                    </a>
                  </li>
                ))}
                <li>
                  <a href="mailto:Goldenrock_uae@yahoo.com" className="text-gray-600 hover:text-blue-600 transition-colors flex items-center gap-2">
                    <i className="ri-mail-line"></i>
                    Goldenrock_uae@yahoo.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-blue-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">© 2024 Golden Rock Electro Mechanical Works L.L.C - All Rights Reserved</p>
            <div className="flex gap-4">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600 transition-colors text-sm">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <a 
        href={`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-green-500 text-white rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="Contact us on WhatsApp"
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>

      {/* Floating Call Button */}
      <a 
        href={`tel:${phoneNumbers[0]}`}
        className="fixed bottom-24 right-6 w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-500 text-white rounded-full flex items-center justify-center shadow-lg hover:from-blue-700 hover:to-blue-600 transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="Call us"
      >
        <i className="ri-phone-line text-2xl"></i>
      </a>
    </div>
  );
}
